import React from 'react'

export type TabProps = {
  /** Tab ID that uniquely identifies it. */
  id: string
  /** Tab title. */
  title: string
  /** Tab contents */
  children: unknown
  onMouseEnter?: () => void
}

const Tab: React.FC<React.HtmlHTMLAttributes<HTMLDivElement> & TabProps> = ({
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  title,
  id,
  children,
  ...other
}) => {
  return (
    <div data-testid={id} key={id} {...other}>
      {children}
    </div>
  )
}

export default Tab
